var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardHeader',{attrs:{"title":"Manage Site"}},[_c('DashboardTiles',{attrs:{"tiles":_vm.tiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }